<title>{{ paymentsPage.htmlTitle }}</title>
<div class="container">
  <app-section [sections]="paymentsPage.ndcPaymentsSections"></app-section>
  <app-section [sections]="paymentsPage.creditCardPaymentSections"></app-section>
  <app-functional-capabilities-ribbon-tile-section [ribbonTileSections]="paymentsPage.ribbonTileSections" [isPaymentsPage]="true"></app-functional-capabilities-ribbon-tile-section>
</div>
